/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_AssetInputs */

const en_view_asset = /** @type {(inputs: View_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Asset`)
};

const es_view_asset = /** @type {(inputs: View_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Activo`)
};

const fr_view_asset = /** @type {(inputs: View_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le bien`)
};

const de_view_asset = /** @type {(inputs: View_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset ansehen`)
};

const id_view_asset = /** @type {(inputs: View_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Aset`)
};

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const ja_view_asset = en_view_asset;

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const zh_view_asset = en_view_asset;

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const ar_view_asset = en_view_asset;

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const it_view_asset = en_view_asset;

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const ru_view_asset = en_view_asset;

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const pt_view_asset = en_view_asset;

/** @type {(inputs: View_AssetInputs) => LocalizedString} */
const ko_view_asset = en_view_asset;

/**
* | output |
* | --- |
* | "View Asset" |
*
* @param {View_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_asset = /** @type {((inputs?: View_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_asset(inputs)
	if (locale === "es") return es_view_asset(inputs)
	if (locale === "fr") return fr_view_asset(inputs)
	if (locale === "de") return de_view_asset(inputs)
	if (locale === "ja") return ja_view_asset(inputs)
	if (locale === "zh") return zh_view_asset(inputs)
	if (locale === "ar") return ar_view_asset(inputs)
	if (locale === "id") return id_view_asset(inputs)
	if (locale === "it") return it_view_asset(inputs)
	if (locale === "ru") return ru_view_asset(inputs)
	if (locale === "pt") return pt_view_asset(inputs)
	return ko_view_asset(inputs)
});